import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import EditNumber from './EditNumber';
import {
  editNumberModalCancel,
  getNumberFeaturesByID,
  updateNumberFeaturesByID,
} from '../../actions/Numbers';
import EditNumberModalEpikBox from './EditNumberModalEpikBox';
import EditCnam from './EditCnam';
import ConfirmationModal from '../ConfirmationModal';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

const EditNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  number = {},
  company,
  type,
  editNumberModalCancel,
  selectRoute,
  gateways,
  user,
  onForceUnlink,
  onUnassign,
}) => {
  const token = localStorage.getItem('jwtToken') || null;
  const [nestedModal, setNestedModal] = useState(false);
  const [showCnam, setShowCnam] = useState(false);
  const [warningText, setWarningText] = useState('');
  const numberForceUnlink = getPermissionForComponent('numberForceUnlink', user.permissionsGroup);
  const dispatch = useDispatch();
  const toggle = () => {
    setNestedModal(!nestedModal);
    editNumberModalCancel();
  };
  const handleForceUnlink = () => {
    if (type === 'fax') {
      setWarningText("This change will remove all associated email addresses.");
    } else {
      onForceUnlink();
    }
  }
  const forceUnlink = (
    <div className="d-flex align-items-center justify-content-end">
      { number?.isNumberLocked &&  <div className='mr-2 font-weight-bold' style={{ color: '#FF0000' }} >Number Lock Enabled</div>}
      {user?.role === 'superAdmin' && number?.company && number?.company?.name !== '__unassigned__' ? (
        <Button className="mr-2" color="primary" onClick={onUnassign}>
          Unassign
        </Button>
      ) : null}
      {(numberForceUnlink === 'write' || numberForceUnlink === 'both' || numberForceUnlink === 'read') && (
        <Button color="primary" onClick={handleForceUnlink} id="force-unlink" disabled={numberForceUnlink == "read"}>
          Force Unlink
        </Button>
      )}
    </div>
  );
  const saveCnam = async data => {
    await dispatch(updateNumberFeaturesByID(token, number._id, data[0]));
    await dispatch(getNumberFeaturesByID(token, number._id));
    setShowCnam(false);
  };
  const handleWarningConfirm = () => {
    onForceUnlink();
    setWarningText('');
  }
  const handleWarningCancel = () => {
    setWarningText('');
  }
  return (
    <>
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader
        close={(user.role === 'superAdmin' || user.role === 'companyGroupAdmin') && forceUnlink}
      >
        {user.role === 'superAdmin' ? <>Edit Number:</> : <>View Number:</>}
        {number.number}
      </ModalHeader>
      <ModalBody>
        <EditNumber selectRoute={selectRoute} gateways={gateways} />
        <Row>
          {company &&
            (type !== 'vmail' &&
              type !== 'dialout' &&
              type !== 'unassigned' &&
              type !== 'forward') && (
              <>
                <Col>
                  <Button
                    disabled={
                      user.role === 'superAdmin' ||
                      user.role === 'companyGroupAdmin' ||
                      user.role === 'supportEngineer'
                        ? false
                        : true
                    }
                    color="primary"
                    onClick={toggle}
                  >
                    Generate uri for epikbox
                  </Button>
                </Col>

                <Modal isOpen={nestedModal} toggle={toggle}>
                  <ModalBody>
                    <EditNumberModalEpikBox />
                  </ModalBody>
                  <ModalFooter>
                    {/* <Button color="primary" onClick={toggle}>Save</Button>{' '} */}
                    <Button color="secondary" onClick={toggle}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </>
            )}
          {number.features && (number.features.callerId || number.features.directoryListing) && (
            <Col>
              <Button
                disabled={
                  user.role === 'superAdmin' ||
                  user.role === 'companyGroupAdmin' ||
                  user.role === 'supportEngineer'
                    ? false
                    : true
                }
                color="primary"
                onClick={() => setShowCnam(true)}
              >
                Edit CNAM
              </Button>
            </Col>
          )}
        </Row>
      </ModalBody>
      <EditCnam isOpen={showCnam} onConfirm={saveCnam} onCancel={() => setShowCnam(false)} />
      <ModalFooter>
        {(user.role === 'superAdmin' ||
          user.role === 'supportEngineer' ||
          (user.role === 'admin' && type === 'dialout') ||
          (user.role === 'enterpriseAdmin' && type === 'dialout') ||
          user.role === 'companyGroupAdmin')
         ? (
          <>
            <Button color="secondary" outline onClick={onCancel} id="edit-cancel-btn">
              Cancel
            </Button>{' '}
            <Button color="primary" onClick={onConfirm} id="edit-save-btn">
              Save
            </Button>
          </>
        ) : (
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
    <ConfirmationModal
      isOpen={Boolean(warningText)}
      onConfirm={handleWarningConfirm}
      onCancel={handleWarningCancel}
      bodyText={warningText}
    />
    </>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.editNumber.company,
  type: state.UIState.numbers.editNumber.type,
  user: state.AppState.user,
  number: state.AppState.numbers.numberByID,
});

const mapDispatchToProps = dispatch => ({
  editNumberModalCancel: () => dispatch(editNumberModalCancel()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNumberModal);
